'use client';
import Image from 'next/image';

const speakers = [
  {
      name: "Sergio Argento",
      designation: "Managing Partner",
      company: "IMPACTA Capital",
      imageSrc: "/images/speakers/sergio-argento.webp",
      alt: "sergio-argento",  
    },
    {
      name: "Harsh Agarwal",
      designation: "Investment Director",
      company: "Cypher Capital",
      imageSrc: "/images/speakers/harsh-agarwal.webp",
      alt: "harsh-agarwal",  
    },
    {
      name: "Anna MacMillan",
      designation: "Co-Founder",
      company: "Venture FactorE / Mintlayer",
      imageSrc: "/images/speakers/anna-macmillan.webp",
      alt: "anna-macmillan",  
    },
    {
      name: "Gaurav Dubey",
      designation: "Co-Founder",
      company: "Crypto Strategy",
      imageSrc: "/images/speakers/gaurav-dubey.webp",
      alt: "gaurav-dubey",  
    },
    {
      name: "Dhaval Parikh",
      designation: "Investment Lead and Fund Manager",
      company: "Sigma Capital",
      imageSrc: "/images/speakers/dhaval-parikh.webp",
      alt: "gaurav-dubey",  
    },
  // end of speaker 2025 speakers
  {
    name: "Aly Madhavji",
    designation: "Managing Partner",
    company: "Blockchain Founders Fund",
    imageSrc: "/images/speakers/aly.webp",
    alt: "Aly",
  },
  {
    name: "Vineet Budki",
    designation: " Partner & CEO",
    company: " Sigma Capital Limited",
    imageSrc: "/images/speakers/vineet.webp",
    alt: "Vineet",
  },
  {
    name: "Luchang Z",
    designation: "Founding Partner",
    company: "Arcanum Capital",
    imageSrc: "/images/speakers/luchang.webp",
    alt: "Luchang",
  },
  {
    name: "Laura K. Inamedinova",
    designation: "Cheif Ecosystem Officer",
    company: "Gate ecosystem / GVC",
    imageSrc: "/images/speakers/laura.webp",
    alt: "Laura",
  },   
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.jsx:73:4" data-component-path="src/app/SpeakerSection.jsx" data-component-line="73" data-component-file="SpeakerSection.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20px-4%20py-%5B60px%5D%20bg-%5B%23EEE8FF%5D%22%7D" id='speakers'
      className="w-full px-4 py-[60px] bg-[#EEE8FF]"
    >
      <div data-component-id="src/app/SpeakerSection.jsx:76:6" data-component-path="src/app/SpeakerSection.jsx" data-component-line="76" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1540px%5D%22%7D" className="w-full max-w-[1540px]">
        {/* Section Title */}
        <h2 data-component-id="src/app/SpeakerSection.jsx:78:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="78" data-component-file="SpeakerSection.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B20px%5D%20mb-10%20sm%3Atext-%5B24px%5D%20lg%3Atext-3xl%20font-semibold%20leading-%5B28px%5D%20sm%3Aleading-%5B32px%5D%20lg%3Aleading-4xl%20text-center%20text-text-accent%20font-poppins%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="text-[20px] mb-10 sm:text-[24px] lg:text-3xl font-semibold leading-[28px] sm:leading-[32px] lg:leading-4xl text-center text-text-accent font-poppins">
              Past Speakers
            </h2>

        {/* Speaker List Box */}
        <div data-component-id="src/app/SpeakerSection.jsx:83:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="83" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20%20max-w-%5B1200px%5D%20mx-auto%22%7D" className="w-full  max-w-[1200px] mx-auto">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div data-component-id="src/app/SpeakerSection.jsx:85:10" data-component-path="src/app/SpeakerSection.jsx" data-component-line="85" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-y-2%20sm%3Agap-y-8%20gap-x-2%20sm%3Agap-x-8%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-2 sm:gap-y-8 gap-x-2 sm:gap-x-8 place-items-center">
            {speakers.map((speaker, index) => (
              <div data-component-id="src/app/SpeakerSection.jsx:87:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="87" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                <div data-component-id="src/app/SpeakerSection.jsx:89:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="89" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B120px%5D%20h-%5B120px%5D%20sm%3Aw-%5B250px%5D%20sm%3Ah-%5B250px%5D%20relative%20mb-4%22%7D" className="w-[120px] h-[120px] sm:w-[250px] sm:h-[250px] relative mb-4">
                  <Image data-component-id="src/app/SpeakerSection.jsx:90:18" data-component-path="src/app/SpeakerSection.jsx" data-component-line="90" data-component-file="SpeakerSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-full%22%7D"
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    height={250}
                    width={250}
                    objectFit="cover"
                    className="rounded-full"
                    unoptimized
                  />
                </div>
                <h3 data-component-id="src/app/SpeakerSection.jsx:100:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="100" data-component-file="SpeakerSection.jsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%233b00ed%5D%20text-%5B13px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="text-[#3b00ed] text-[13px] sm:text-[18px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/SpeakerSection.jsx:103:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="103" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-black%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%22%7D" className="text-black text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/SpeakerSection.jsx:106:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="106" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-black%20text-%5B10px%5D%20sm%3Atext-%5B12px%5D%20text-center%22%7D" className="text-black text-[10px] sm:text-[12px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
